module.exports = __webpack_public_path__ + "assets/img/404.5f76e018.png";